<p-table [value]="data()" rowHover="true">
  <ng-template #header>
    <tr>
      <th pSortableColumn="workItemName" style="width: 25%">
        Nazwa
        <p-sortIcon field="workItemName" />
      </th>
      @if (isOwner()) {
        <th pSortableColumn="userName" style="width: 15%">
          Użytkownik
          <p-sortIcon field="userName" />
        </th>
      }
      <th pSortableColumn="description" style="width: 35%">
        Opis
        <p-sortIcon field="description" />
      </th>
      <th pSortableColumn="billable" style="width: 7%">
        Płatny
        <p-sortIcon field="billable" />
      </th>
      <th pSortableColumn="revenue" style="width: 8%">
        Wynagrodzenie
        <p-sortIcon field="revenue" />
      </th>
      <th pSortableColumn="startTime" style="width: 15%">
        Data
        <p-sortIcon field="startTime" />
      </th>
      <th pSortableColumn="duration" style="width: 15%">
        Czas
        <p-sortIcon field="duration" />
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td data-label="Nazwa">
        <div class="flex items-center">
          <span
            class="w-1 self-stretch rounded me-3 flex-shrink-0"
            [style.background-color]="item.color || 'var(--app-border)'"
            [title]="'Kolor: ' + (item.color || 'brak')"
          ></span>

          <div class="flex items-center gap-1">
            @if (isOwner()) {
              <span *ngIf="item.workItemName" class="font-medium">
                <a
                  [routerLink]="['/work-items', item.workItemId]"
                  class="hover:underline text-primary-600 dark:text-primary-300"
                >
                  {{ item.workItemName }}
                </a>
              </span>
            } @else {
              <span *ngIf="item.workItemName" class="font-medium">
                {{ item.workItemName }}
              </span>
            }

            <span *ngIf="!item.workItemName" class="font-medium">
              {{ item.clientName }}
            </span>

            <small *ngIf="item.workItemName" class="text-gray-500 dark:text-gray-400">
              {{ item.clientName ? ' - ' + item.clientName : '' }}
            </small>
          </div>
        </div>
      </td>
      @if (isOwner()) {
        <td data-label="Użytkownik">{{ item.userName }}</td>
      }
      <td data-label="Opis">{{ item.description }}</td>
      <td data-label="Płatny">{{ item.billable ? 'Tak' : 'Nie' }}</td>
      <td
        data-label="Wynagrodzenie"
        [pTooltip]="
          item.ratePerHour
            ? 'Stawka: ' + (item.ratePerHour | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL')
            : item.effectivePercentage != null
              ? 'Efektywny %: ' + item.effectivePercentage + '%'
              : 'Brak stawki'
        "
        tooltipPosition="bottom"
      >
        <div class="flex flex-col items-end gap-0.5">
          <span class="font-semibold text-[var(--app-text)]">
            {{ (item.earnings ?? item.revenue) | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL' }}
          </span>
          @if (item.billingMode === 'REVENUE_THRESHOLD') {
            <span class="text-xs text-gray-500 dark:text-gray-400">
            Kwota wpisu: {{ item.revenue | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL' }}
            </span>
          }
        </div>
      </td>
      <td data-label="Data">
        <div class="flex flex-col">
          <span class="font-medium">{{ formatTimeRange(item.startTime, item.endTime) }}</span>
          <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(item.startTime) }}</span>
        </div>
      </td>
      <td data-label="Czas">
        <span class="font-medium">
          {{ item.duration | minutesToHours: 'hh:mm:ss' }}
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="text-center">
        <div class="flex flex-row items-center justify-center gap-3 py-5">
          <i class="pi pi-info-circle text-4xl text-gray-400 dark:text-gray-500"></i>
          <span class="app-muted font-medium">Brak danych do wyświetlenia.</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
